import React from "react";
import { Helmet } from "react-helmet-async";
import image from "../assets/img/page1-img1.jpg"
export default function AboutPage() {
  return (
    <section className="section container" style={{ paddingTop: "8rem" }}>
      
      <Helmet>
        <title>About Topgun Aviation Academy</title>
        <meta
          name="description"
          content="Learn about Topgun Aviation Academy: our mission, key features, and how we build the best military aviation experience."
        />
      </Helmet>
      <h1 className="section__title section__title-gradient">About Us</h1>
<img src={image} className="img-top"/>
      <div style={{ lineHeight: "2rem" }}>
        <p>
          Topgun Aviation Academy is built for aviation enthusiasts, students, and
          military aviation professionals who want a fast, visual, and reliable way
          to explore aircraft data, media, and interactive experiences.
        </p>

        <h2 style={{ marginTop: "2rem" }}>Our mission</h2>
        <p>
          Our mission is to make military aviation knowledge more accessible and
          engaging—combining structured aircraft profiles with rich media and
          modern experiences like 3D and AR.
        </p>

        <h2 style={{ marginTop: "2rem" }}>What you can do with Topgun</h2>
        <ul>
          <li>Explore a large military aircraft catalog with detailed profiles.</li>
          <li>Use search and filters to quickly find the aircraft you need.</li>
          <li>Save aircraft to Favorites for quick access.</li>
          <li>Rate and comment to participate in the community.</li>
          <li>Experience selected aircraft with 3D and AR features (where available).</li>
        </ul>

        <h2 style={{ marginTop: "2rem" }}>How we improve the app</h2>
        <p>
          We use analytics to understand how the app is used and to improve
          stability, performance, and overall user experience. For details, please
          read our Privacy Policy.
        </p>

        <h2 style={{ marginTop: "2rem" }}>Contact</h2>
        <p>If you have questions, feedback, or business inquiries:</p>
        <ul>
          <li>
            <strong>Email:</strong> support@yourdomain.com
          </li>
          <li>
            <strong>App Store:</strong>{" "}
            <a
              href="https://apps.apple.com/us/app/topgun-aviation-academy/id6738648694"
              target="_blank"
              rel="noreferrer"
            >
              Topgun Aviation Academy
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}
